import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords, getRecords_new } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import ProjectsComp from "../Common/ProjectsHome";
import NearByProperties from "../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import { buildFilterString, getWishList_new } from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import SidebarProjects from "../Common/SideBarProjects";
import { Drawer } from "@mui/material";
import SidebarFilter from "../Common/SidebarFilter";
import LoginDialog from "../Common/LoginDialog";

function ViewAllProjects() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    coordinates,
    setcoordinates,

    searchData,
    setsearchData,
    wishlist,
    setWishlist,
  } = useContext(ApiContext);

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [openLogin, setOpenLogin] = useState(false);
  const params = new URLSearchParams(location.search);
  const initialFilters = location?.state?.filters || new FilterParams();

  const flag = location?.state?.flag;
  const tabID = 384;

  const [data, setdata] = useState([]);
  const [filters, setFilters] = useState(initialFilters);

  const [Loading, setLoading] = useState(true);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState(-1);
  // const getSearchResults = () => {
  //   setLoading(true);

  //   let filters = "";

  //   if (flag == 1) {
  //     filters = `{CityID: { $in: [${cityID}] }}`;
  //   } else if (flag == 2) {
  //     filters = `{}`;
  //   } else {
  //     filters = `{SocietyID: { $in: [${cityID}] }}`;
  //   }

  //   getRecords(398, 1000, filters, 1, "", (res) => {
  //     //  console.log("Search Results:", res);

  //     if (res.hasErrors === false) {
  //       if (res?.response?.records.length > 0) {
  //         setdata(res?.response?.records || []);

  //         setLoading(false);
  //       } else {
  //         setLoading(false);
  //       }
  //     } else {
  //       setLoading(false);
  //     }
  //   });
  // };

  useEffect(() => {
    getSearchResults(filters);
  }, [filters, order, sort]);

  const getSearchResults = async (filters) => {
    setLoading(true);

    let mongoFilterString;

    if (filters?.wishlist == true) {
   const wishlistData = await getWishList_new();

      const wishlist = wishlistData
        ?.filter(
          (item) =>  item.IsListingID == 2,
        )
        ?.map((item) => item.ListingID)
        ?.join(",");

      //console.log("wishlist", wishlist);

      let additionalfilters = buildFilterString(filters);

      mongoFilterString = ` 'SocietyID': { $in: [${wishlist}] }${
        additionalfilters ? `, ${additionalfilters}` : ""
      } `;
    } else {
      mongoFilterString = buildFilterString(filters);
    }

    getRecords_new(
      398,
      1000,
      `{${mongoFilterString}}`,
      1,
      "",
      order,
      sort,
      (res) => {
        // console.log("Search Results:", res);

        if (res.hasErrors === false) {
          if (res?.response?.records != null) {
            setdata(res?.response?.records || []);

            setLoading(false);
          } else {
            setdata([]);
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      },
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <Header />

        <div className="content-wrapper">
          {/* Breadcrumb Start */}
          {/* <div className="breadcrumb-wrap bg-f br-1">
          <div className="container">
            <div className="breadcrumb-title">
              <h2>
                {" "}
                {flag == 1
                  ? `Projects in ${city}`
                  : flag == 2
                    ? "All Projects"
                    : `Projects in ${city}`}
              </h2>
            </div>
          </div>
        </div> */}
          {/* Breadcrumb End */}

          {/* Listing section start */}
          <section className="listing-wrap ptb-30">
            <div className="container">
              <div className="row gx-5">
                <div className="col-xl-12">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="d-desk">
                        <SidebarProjects
                          filters={filters}
                          tabID={tabID}
                          onChange={setFilters}
                        />
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="fixheight">
                        <div className="fxmobilediv mb-25">
                          <div className="fixonmobile">
                            <button
                              type="button"
                              className="btn style3 loginbtn d-mobile mb-10"
                              onClick={(e) => {
                                setOpen(true);
                                e.preventDefault();
                              }}
                              style={{ width: "100%" }}
                            >
                              {" "}
                              <i
                                className="ri-filter-3-fill"
                                style={{ color: "#16a34a" }}
                              ></i>{" "}
                              Filters
                            </button>

                            <div
                              className="profuct-result d-flex"
                              style={{ justifyContent: "space-between" }}
                            >
                              <p style={{ marginBottom: 0 }}>
                                {data?.length || 0} Results Found
                              </p>

                              <div className="filter-item-cat">
                                <select
                                  onChange={(e) => {
                                    const value = Number(e.target.value);

                                    if (value === 1) {
                                      setSort("");
                                      setOrder(-1);
                                    } else if (value === 2) {
                                      setSort("MaxPrice");
                                      setOrder(-1);
                                    } else if (value === 3) {
                                      setSort("MaxPrice");
                                      setOrder(1);
                                    }
                                  }}
                                >
                                  <option value={1}>Newest First</option>
                                  <option value={2}>Price : High To Low</option>
                                  <option value={3}>Price : Low To High</option>
                                </select>
                              </div>

                              {/* <button                      
                      className="btn style2 btnx d-mobile"
                      style={{
                        padding: "0px 39px 0px 14px",
                        marginLeft: 10,
                      }}
                    
                    >
                      <i className="ri-filter-3-fill"   onClick={(e) => {
                        setOpen(true);
                        e.preventDefault();

                      }}></i> 
                    </button> */}
                            </div>
                          </div>
                        </div>
                        {data?.map((item, index) => (
                          <ProjectsComp
                            key={index}
                            {...item}
                            onheartClick={() => setOpenLogin(true)}
                          />
                        ))}
                        {/* <div className="col-lg-64 col-md-4">
                    <div className="property-card style2">
                      <div className="property-img-slider">
                        <img
                          src="assets/img/property/property-10.jpg"
                          alt="Image"
                        />
                      </div>
                      <div className="property-info">
                        <div className="property-status-wrap">
                          <span className="property-status">For Rent</span>
                          <p className="property-price">
                            $34,900/<span>month</span>
                          </p>
                        </div>
                        <h3>
                          <a href="listing-details.html">Villa In Luis Park</a>
                        </h3>
                        <p>
                          <i className="flaticon-location" />
                          64, 1st Aveneu, High Steet, USA
                        </p>
                        <ul className="property-metainfo list-style">
                          <li>
                            <i className="flaticon-double-bed" />
                            06
                          </li>
                          <li>
                            <i className="flaticon-bath-tub" />
                            04
                          </li>
                          <li>
                            <i className="flaticon-square" />
                            3100 sqft
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Listing section end */}
          {Loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255,255,255,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
              }}
            >
              <TailSpin color="#00BFFF" height={80} width={80} />
            </div>
          )}

          <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)}>
            <div className="bottomdrawer" style={{ position: "relative" }}>
              <div className="psticky">
                <h6>Filters</h6>
                {/* Close button */}
                <button
                  onClick={() => setOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>
              <SidebarProjects
                filters={filters}
                tabID={tabID}
                onChange={setFilters}
              />
            </div>
          </Drawer>
        </div>
        <Footer />
        <LoginDialog
          open={openLogin}
          onClose={() => setOpenLogin(false)}
          onSuccess={(data) => {
            if (data) {
              //  console.log("Login Success:", data);
              setLogindata(data);
              setlogindata(data);

              localStorage.setItem("loginData", JSON.stringify(data));
            }

            //  setUser(data);
          }}
          onUserDetails={(userDetails) => {
            if (userDetails) {
              // console.log("User Details:", userDetails);
              setUserdata(userDetails);
              setuserData(userDetails);
              localStorage.setItem("UserData", JSON.stringify(userDetails));
            }
          }}
        />
      </div>
    </>
  );
}

export default ViewAllProjects;
